import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DataFilterDisplayService } from '../../interface';
import { TranslateService } from '@ngx-translate/core';
import { formatDate } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class DateInputDisplayService implements DataFilterDisplayService {
  constructor(private readonly translateService: TranslateService) {}
  getDisplay(value: Date | number): Observable<string> {
    let display: string | null = '';

    switch (typeof value) {
      case 'number':
        return of(`<b>${value} days</b>`);
    }

    display = formatDate(value, 'MMM dd, yyyy h:mm a ', 'en-US');
    return of(`<b>${display}</b>`);
  }
}
